import * as React from 'react';
import { useIntl } from 'react-intl';

import { Text } from '@notino/react-styleguide';

import { VariantDisplay } from '../../../../FetchDoneBlock/ReviewItemDisplay/VariantDisplay';
import { sortFilterBarMessages } from '../../../messages';
import {
  ReviewFilterCategory,
  useReviewFiltersStore,
} from '../../../Stores/filtersStore';

import { ChipCount, ChipTitleWrapper, Star, Title } from './styled';

interface ChipTitleProps {
  defaultTitle: React.ReactElement;
  category: ReviewFilterCategory;
}

export const ChipTitle: React.FC<ChipTitleProps> = ({
  defaultTitle,
  category,
}) => {
  const allSelections = useReviewFiltersStore((state) => state.selections);

  const { formatMessage } = useIntl();

  const selectedCount = allSelections[category]?.length;
  const firstSelectedCategory = allSelections[category][0];

  const isRating = category === 'rating';
  const isVariants = category === 'variants';
  const isContentType = category === 'contentTypes';
  const isShops = category === 'shops';

  return (
    <ChipTitleWrapper>
      {selectedCount ? (
        <Title>
          <span>
            {isVariants ? (
              <VariantDisplay catalogId={String(firstSelectedCategory)} />
            ) : isContentType ? (
              formatMessage(
                sortFilterBarMessages[`contentType${firstSelectedCategory}`]
              )
            ) : isShops ? (
              <Text typography="labelSmall400" color="text.secondary">
                {firstSelectedCategory}
              </Text>
            ) : (
              firstSelectedCategory
            )}
            {isRating ? <Star>*</Star> : ''}
          </span>
          {selectedCount > 1 && <ChipCount>+{selectedCount - 1}</ChipCount>}
        </Title>
      ) : (
        defaultTitle
      )}
    </ChipTitleWrapper>
  );
};
